import React from 'react';

const PrivacyPolicy = () => {
  // const [accepted, setAccepted] = useState(false);

  return (
    <div className=" py-8 sm:px-6 lg:px-8">
      <div className="bg-gray-200 shadow-lg rounded-lg overflow-hidden">
        <div className="p-6 sm:p-8">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
            <p className="text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          {/* Scrollable Content */}
          <div className="min-h-screen  mb-8 p-4 border border-gray-200 rounded-lg">
            <div className="space-y-6">
              <section>
                <h2 className="text-xl font-semibold text-green-600 mb-3">1. Introduction</h2>
                <p className="text-gray-700 leading-relaxed">
                  Welcome to our Privacy Policy. Your privacy is critically important to us. This policy explains 
                  how we collect, use, disclose, and safeguard your information when you use our services.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-600 mb-3">2. Information We Collect</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-2">Personal Information:</h3>
                    <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                      <li>Name and contact details (email, phone number, address)</li>
                      <li>Account credentials and profile information</li>
                      <li>Payment and billing information</li>
                      <li>Demographic information</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-2">Technical Information:</h3>
                    <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                      <li>IP address and device information</li>
                      <li>Browser type and version</li>
                      <li>Usage data and analytics</li>
                      <li>Cookies and tracking technologies</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-600 mb-3">3. How We Use Your Information</h2>
                <p className="text-gray-700 leading-relaxed mb-3">We use the information we collect to:</p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Process transactions and send related information</li>
                  <li>Send administrative messages and updates</li>
                  <li>Respond to comments and customer service requests</li>
                  <li>Personalize user experience and content</li>
                  <li>Monitor and analyze trends and usage</li>
                  <li>Detect, prevent, and address technical issues</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-600 mb-3">4. Cookies and Tracking Technologies</h2>
                <p className="text-gray-700 leading-relaxed">
                  We use cookies and similar tracking technologies to track activity on our service and hold certain information. 
                  Cookies are files with a small amount of data which may include an anonymous unique identifier.
                </p>
                <div className="mt-3 p-3 rounded">
                  <p className="text-sm font-bold text-gray-600">
                    You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. 
                    However, if you do not accept cookies, you may not be able to use some portions of our service.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-600 mb-3">5. Data Sharing and Disclosure</h2>
                <p className="text-gray-700 leading-relaxed mb-3">We may share your information with:</p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Service providers and business partners</li>
                  <li>Legal authorities when required by law</li>
                  <li>Third parties in connection with a business transaction</li>
                  <li>Other users with your consent</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-3">
                  We do not sell your personal information to third parties.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-600 mb-3">6. Data Security</h2>
                <p className="text-gray-700 leading-relaxed">
                  We implement appropriate technical and organizational security measures to protect your personal information. 
                  However, please remember that no method of transmission over the Internet or electronic storage is 100% secure.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-600 mb-3">7. Your Data Protection Rights</h2>
                <p className="text-gray-700 leading-relaxed mb-3">Depending on your location, you may have the following rights:</p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><strong>Access:</strong> Right to access your personal information</li>
                  <li><strong>Rectification:</strong> Right to correct inaccurate data</li>
                  <li><strong>Erasure:</strong> Right to delete your personal data</li>
                  <li><strong>Restriction:</strong> Right to restrict processing of your data</li>
                  <li><strong>Portability:</strong> Right to data portability</li>
                  <li><strong>Objection:</strong> Right to object to data processing</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-600 mb-3">8. Data Retention</h2>
                <p className="text-gray-700 leading-relaxed">
                  We will retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy. 
                  We will retain and use your information to the extent necessary to comply with our legal obligations.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-600 mb-3">9. International Data Transfers</h2>
                <p className="text-gray-700 leading-relaxed">
                  Your information may be transferred to and maintained on computers located outside of your state, province, 
                  country, or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-600 mb-3">10. Children's Privacy</h2>
                <p className="text-gray-700 leading-relaxed">
                  Our service does not address anyone under the age of 13. We do not knowingly collect personally 
                  identifiable information from children under 13. If you are a parent or guardian and you are aware 
                  that your child has provided us with personal data, please contact us.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-600 mb-3">11. Changes to This Privacy Policy</h2>
                <p className="text-gray-700 leading-relaxed">
                  We may update our Privacy Policy from time to time. We will notify you of any changes by posting 
                  the new Privacy Policy on this page and updating the "Last updated" date.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-600 mb-3">12. Contact Us</h2>
                <p className="text-gray-700 leading-relaxed">
                  If you have any questions about this Privacy Policy, please contact us:
                </p>
                <div className="mt-2 space-y-1">
                  <p className="text-gray-700">Email: <a href="mailto:privacy@yourcompany.com" className="text-green-600 hover:text-green-800 underline">privacy@yourcompany.com</a></p>
                  <p className="text-gray-700">Address: [Your Company Address]</p>
                  <p className="text-gray-700">Phone: [Your Contact Number]</p>
                </div>
              </section>
            </div>
          </div>

          {/* Acceptance Section */}
          {/* <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
            <div className="flex items-center mb-4">
              <input
                type="checkbox"
                id="accept-privacy"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
                className="h-5 w-5 text-green-600 rounded focus:ring-green-500"
              />
              <label htmlFor="accept-privacy" className="ml-3 text-gray-700 font-medium">
                I have read and understand the Privacy Policy
              </label>
            </div>
            
            <div className="flex space-x-4">
              <button
                className={`flex-1 py-3 px-4 rounded-md font-medium transition-colors duration-200 ${
                  accepted
                    ? 'bg-green-600 hover:bg-green-700 text-white cursor-pointer'
                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
                disabled={!accepted}
              >
                Accept Privacy Policy
              </button>
              <button
                className="flex-1 py-3 px-4 bg-gray-200 text-gray-700 rounded-md font-medium hover:bg-gray-300 transition-colors duration-200"
              >
                Download PDF
              </button>
            </div>
          </div> */}

          {/* Footer Note */}
          <div className="mt-4 text-center">
            <p className="text-sm text-gray-500">
              This Privacy Policy complies with GDPR, CCPA, and other data protection regulations.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;